import { useEffect, useRef } from "react";
import { useLocation, useMatch } from "react-router-dom";

// Counter ids mirror public/metrika.js and the <noscript> pixels in
// public/index.html. Kept in sync manually — if they change, update all three.
const METRIKA_IDS = [110070338, 113131263];

// TV / tablet screen-mode pages load once and stay open for hours polling the
// display API. We exclude them from analytics so the "visitors" and "bounce"
// metrics aren't dominated by venue hardware.
const SCREEN_MODE_PATH = "/place/:slug/screen";

// SPA route-change tracker for Yandex.Metrika. The snippet in <head> sends the
// initial pageview (via ssr:true + url/referrer passed to init); this component
// fires a hit on every subsequent route change. Renders nothing.
export default function MetrikaTracker() {
  const location = useLocation();
  const isScreenMode = Boolean(useMatch(SCREEN_MODE_PATH));
  const previousUrlRef = useRef(window.location.href);
  const initialRunRef = useRef(true);

  useEffect(() => {
    if (initialRunRef.current) {
      initialRunRef.current = false;
      previousUrlRef.current = window.location.href;
      return;
    }
    if (isScreenMode) return;
    if (typeof window.ym !== "function") return;

    const url = window.location.href;
    const referer = previousUrlRef.current;
    METRIKA_IDS.forEach((id) => {
      window.ym(id, "hit", url, { referer, title: document.title });
    });
    previousUrlRef.current = url;
  }, [location.pathname, location.search, isScreenMode]);

  return null;
}
